




import {Component, Ref, Vue} from "vue-property-decorator";
import PriorityRules from "@/pages/Pages/Rules/PriorityRules.vue";
import {MsgTransports} from "@/store/types";

@Component({components: {PriorityRules}})
export default class SmsPriorityRules extends Vue {
  private smsTransport: MsgTransports = MsgTransports.SMS
}
